import { useEffect, useMemo, useState } from 'react'
import {
  dateToDB,
  formatAmount,
  formatPipe,
  formatter,
  getSellStatus,
  getYearMonthAndDay,
} from '../../../utils/utils'
import ViewWithTabs, {
  DataTabView,
} from '../../../components/Display/ViewWithTabs'
import Modal from '../../../components/Display/Modal'
import { fetchSells } from '../../../redux/actions/sells'
import { useLocalStorageState } from '../../../hooks/useLocalStorageState'
import { useForm } from 'react-hook-form'
import Form from '../../../components/Form'
import FormItem from '../../../components/Form/FormItem'
import Select from '../../../components/Inputs/Select'
import Button from '../../../components/General/Button'
import InputText from '../../../components/Inputs/InputText'
import Tooltip from '../../../components/Display/Tooltip'
import Datepicker from '../../../components/Inputs/Datepicker'
import InputCheck from '../../../components/Inputs/InputCheck'
import CurrencyInput from '../../../components/Inputs/CurrencyInput'
import Bancrecer from '../../../assets/images/bancrecer.svg'

const MobilePaymentForm: React.FC<WalletFormProp> = ({
  onCancel,
  onSubmitProp,
  total,
  debt,
  rate,
}) => {
  const form = useForm({
    defaultValues: {
      amount: 0,
    },
  })

  const onSubmit = (values): void => {
    if (isManual) {
      onSubmitProp({
        ...values,
        amount: +formatPipe(values.amount, true),
        isManual,
      })
      return
    }

    onSubmitProp({
      ...values,
      amount: +formatPipe(values.amount, true),
      isManual,
      date: dateToDB(values?.date),
    })
  }

  const usdDebt = useMemo(
    () =>
      formatPipe(
        (+debt / +(rate.find((r) => r.id === '1')?.rate || 1)).toFixed(2)
      ),
    [debt, rate]
  )

  useEffect(() => {
    form.setValue('amount', `Bs. ${formatPipe(debt + '')}`)
  }, [])

  const banksOptions = [
    {
      value: '0102',
      text: 'Banco de Venezuela',
    },
    {
      value: '0191',
      text: 'Banco Nacional de Credito',
    },
    {
      value: '0108',
      text: 'Banco Provincial',
    },
    {
      value: '0114',
      text: 'Bancaribe',
    },
    {
      value: '0115',
      text: 'Banco Exterior',
    },
    {
      value: '0163',
      text: 'Banco del Tesoro',
    },
    {
      value: '0134',
      text: 'Banesco',
    },
    {
      value: '0138',
      text: 'Banco Plaza',
    },
    {
      value: '0174',
      text: 'Banplus',
    },
    {
      value: '0169',
      text: 'Mi Banco',
    },
    {
      value: '0157',
      text: 'DEL SUR BU',
    },
    {
      value: '0168',
      text: 'Bancrecer',
    },
    {
      value: '0171',
      text: 'Banco Activo',
    },
    {
      value: '0151',
      text: 'BFC',
    },
    {
      value: '0172',
      text: 'Bancamiga',
    },
    {
      value: '0105',
      text: 'Mercantil',
    },
    {
      value: '0151',
      text: 'BFC',
    },
    {
      value: '0177',
      text: 'BANFANB',
    },
    {
      value: '0175',
      text: 'Bicentenario',
    },
    {
      value: '0137',
      text: 'SOFITASA',
    },
    {
      value: '0166',
      text: 'Agricola',
    },
    {
      value: '0128',
      text: 'Caroni',
    },
    {
      value: '0156',
      text: '100% Banco',
    },
    {
      value: '0104',
      text: 'Venezolano de Credito',
    },
  ]

  const [isManual, setIsManual] = useState<boolean>(false)

  return (
    <>
      <Form
        form={form}
        classes={`gap-x-6 gap-y-2`}
        onSubmit={(values) => onSubmit(values)}
      >
        <div
          className="col-span-12"
          style={{ color: '#102b6d', fontWeight: 500 }}
        >
          Pago Móvil
        </div>

        {!isManual && (
          <FormItem
            name="originNumber"
            classes="col-span-12"
            defaultValue={''}
            rules={{
              required: 'Es necesario el número de origen',
            }}
          >
            {/* <InputText small maxLength={80} /> */}
            <InputText
              label="Nro de Origen"
              innerProps={{
                type: 'number',
                pattern: 'd*',
              }}
            />
          </FormItem>
        )}

        <FormItem
          name="amount"
          classes="col-span-12"
          defaultValue={''}
          rules={{
            required: 'Es necesario el monto',
            // pattern: { value: /^\d+(\.\d{2})?$/, message: 'Monto inválido' },
          }}
        >
          {/* <InputText small maxLength={80} /> */}
          {/* <InputNumber addDecimals={true} label='Monto'/> */}
          <CurrencyInput addDecimals={true} label="Monto" mask="Bs. num" />
        </FormItem>

        {!isManual && (
          <FormItem
            name="bank"
            classes="col-span-12"
            rules={{ required: 'Es necesario el banco' }}
          >
            <Select
              label="Banco"
              defaultValue={banksOptions[0]}
              options={banksOptions}
              setSelectedHelper={(v) => {
                console.log('V', v?.value)
                if (v?.value) {
                }
              }}
            />
          </FormItem>
        )}

        {!isManual && (
          <FormItem
            name="date"
            classes="col-span-12"
            rules={{
              required: 'Es necesario el numero de referencia',
            }}
          >
            <Datepicker small label="Fecha" />
          </FormItem>
        )}

        <FormItem
          name="ref"
          classes="col-span-12"
          rules={{
            required: 'Es necesario el numero de referencia',
          }}
        >
          <InputText small label="Referencia" />
        </FormItem>

        <div className="col-span-12 flex flex-row items-center">
          <div className="mr-3">Verificación Manual</div>
          <FormItem name="isManual" defaultValue={false}>
            <Tooltip
              title={
                'Al verificar manualmente, tu como usuario das garantía que el pago sea realizado de manera exitosa'
              }
            >
              {/* <Switch  forForm={true} value={isManual} onChange={(v) => setIsManual(v)} /> */}
              <InputCheck
                value={isManual}
                onChange={(v) => {
                  // console.log("V", v.target.checked)
                  setIsManual(v.target.checked)
                }}
              />
            </Tooltip>
          </FormItem>
        </div>

        <div className="col-span-12 h-full flex flex-row">
          <div className="w-1/2 mr-5 pl-1">
            <Button type="outline" classes="w-full" onClick={() => onCancel()}>
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button type="primary" classes="w-full" htmlType="submit">
              Continuar
            </Button>
          </div>
        </div>

        <div
          style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
          className="col-span-12 mt-3"
        ></div>

        <div className="col-span-12 mt-3 flex flex-col items-center">
          <label className="text-center text-sm" style={{ color: '#7C7C7C' }}>
            Operación realizada a través de la plataforma de Bancrecer
          </label>
          <div className="mt-3">
            <img src={Bancrecer} height={100} width={100} />
          </div>
        </div>
      </Form>
    </>
  )
}

interface WalletFormProp {
  onSubmitProp: Function
  onCancel: Function
  total: number
  debt: number | string
  rate?: any
}

interface options {
  value: string
  text: string
}

enum valuesEnum {
  national = 'nationalTransfer',
  mobile = 'mobilePayment',
}

export default MobilePaymentForm